<template>
  <div class="list">
    <div class="table">
      <table-temp
        title
        :flag="1"
        :tableData="tableData"
        :columnData="tableConf"
        text="详情"
        :isEdit="false"
        @editTable="editTable"
        @handleSelectionCode="handleSelectionCode"
      >
        <div slot="tool" class="listBtn">
          <el-button
            class="borderBtn"
            v-for="(item, index) of btnGroup"
            :type="item == 'new' ? 'primary' : null"
            :key="index"
            :disabled="tableData.length > 0"
            @click="changeType(item)"
            >{{ flags[item]
            }}<i
              class="button-icon"
              :class="{
                'icon-xinshe': item == 'new',
                'icon-qianru': item == 'add',
                'icon-biangeng': item == 'update',
              }"
            ></i
          ></el-button>
        </div>
        <template slot="other">
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editTable(scope)"
                >详情</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="delTable(scope)"
                v-if="[0, 4].includes(scope.row.checkState)"
                >删除</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="[0, 4].includes(scope.row.checkState)"
                @click="fillList(scope)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="[3].includes(scope.row.checkState)"
                @click="changeStatus(scope)"
                >变更</el-button
              >
            </template>
          </el-table-column>
        </template>
      </table-temp>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

import TableTemp from "@table/table1";
import { list } from "@/conf/newAgency";
import { getFundList, getDetailMgr, delMessage } from "common/js/api";
import { mapMutations } from "vuex";

export default {
  components: {
    TableTemp,
  },

  data() {
    return {
      flags,
      tableData: [],
      tableConf: list,
      // btnGroup: ["new", "update", "add"],
      btnGroup: ["new", "add"],

      active: "new",
      userCode: "",
      selectData: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      listTags: {
        0: ["info", "未提交"],
        1: ["", "待审核"],
        2: ["warning", "审核中"],
        3: ["success", "已通过"],
        4: ["danger", "未通过"],
      },
      isShowdel: false,
      idCode: "",
    };
  },
  // 测试code JG472449
  mounted() {
    this.userCode = this.Cookies.get("identifyCode");
    this.getList();
  },

  methods: {
    async fillList(scope) {
      const codeId = scope.row.institutionCode;
      const res = await getDetailMgr(codeId);
      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      this.$router.push({
        path: "/FundManagement/NewAgency",
        query: {
          flag: "update",
          codeId: codeId,
          step: 0,
        },
      });
    },
    //详情
    editTable(scope) {
      const id = scope.row.id;
      const checkState = scope.row.checkState;
      const commitTime = scope.row.commitTime;
      this.$router.push({
        path: "/FundManagement/FundDetail",
        query: {
          flag: this.active,
          institutionCode: scope.row.institutionCode,
          checkState: checkState,
          date: commitTime,
        },
      });
    },

    changeType(item) {
      this.active = item;
      if (item == "update") {
        this.getUpdateDetail();
        return;
      }
      this.$router.push({
        path: "/FundManagement/NewAgency",
        query: {
          flag: item,
        },
      });
      // this.getList();
    },

    async getList() {
      const data = {
        userInstitutionCode: this.userCode,
        institutionType: "GL",
        page: this.currentPage,
        size: this.pageSize,
      };
      this.changeLoadingstate(true);
      const { result } = await getFundList(data);
      result.list.forEach((item) => {
        item.checkFeedback = item.checkFeedback || "--";
      });
      this.tableData = result.list;
      this.tableData.map((item) => {
        if (item.checkState === 0 || item.checkState === 4) {
          this.isShowdel = true;
        } else {
          this.isShowdel = false;
        }
        this.idCode = item.institutionCode;
      });
      this.total = result.total;
      this.currentPage = result.pageNum;
      this.pageSize = result.pageSize;
    },

    //变更更改
    async changeStatus(scope) {
      const institution = scope.row;

      const codeId = institution.institutionCode;
      const res = await getDetailMgr(codeId);

      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      this.$router.push({
        path: "/FundManagement/NewAgency",
        query: {
          flag: "update",
          codeId: codeId,
          step: 0,
        },
      });
    },
    //删除
    delTable(scope) {
      this.idCode = scope.row.institutionCode;
      delMessage(this.idCode).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getList();
        }
      });
    },
    //  未确定变更方式 先写第一条id
    // async getUpdateDetail() {
    //   if (!this.checkState()) return;
    //   const institution = this.selectData[0];
    //   console.log("TCL: getUpdateDetail -> institution", institution);
    //   if (institution.checkState == 2) {
    //     this.$message({
    //       message: "抱歉!正在机构正在审核中,不能进行变更",
    //       type: "warning"
    //     });
    //     return;
    //   }
    //   const codeId = institution.institutionCode;
    //   const res = await getDetailMgr(codeId);
    //   this.setMgrData({
    //     codeId: codeId,
    //     value: res.result
    //   });
    //   this.$router.push({
    //     path: "/FundManagement/NewAgency",
    //     query: {
    //       flag: "update",
    //       codeId: codeId,
    //       step: 0
    //     }
    //   });
    // },

    // checkState() {
    //   if (this.selectData.length > 1) {
    //     this.$message({
    //       message: "变更只支持同时变更一个机构,请选择一个机构进行变更!",
    //       type: "warning"
    //     });
    //     return false;
    //   }
    //   if (!this.selectData.length) {
    //     this.$message({
    //       message: "请选择机构进行变更!",
    //       type: "warning"
    //     });
    //     return false;
    //   }
    //   return true;
    // },

    handleSelectionCode(codeList) {
      this.selectData = codeList;
    },

    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    ...mapMutations(["setMgrData", "changeLoadingstate"]),
  },
};
</script>

<style scoped lang="scss">
.list {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #cccccc80;
  height: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
  padding: 20px;
  > .table {
    flex: 1;
  }
}

::v-deep .type-title {
  &::before {
    display: none;
  }
}
</style>
